export default "__VITE_ASSET__Bu5AzS5g__"